<template>
    <div>    
    <div class="accordion" role="tablist" v-for="(trucker,index) in truckers" :key="index">
    <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'accordion'+index" variant="info">{{ trucker.created_at}}</b-button>
        </b-card-header>
        <b-collapse  :id="'accordion'+index" :visible="index== 0 ?true : false"  role="tabpanel">
          <b-card-body>
            <div class="row">
                <div class="col-md-4">
                    <h4><b>Kunde info</b></h4>
                    <div class="row">
                        <div class="col-md-5 mb-2">
                            <b>Navn</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).name }}</div>
                        <div class="col-md-5 mb-2">
                            <b>E-mail</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).email }}</div>
                        <div class="col-md-5 mb-2">
                            <b>CVR Nummer</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).cvr }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Vognmands nr.</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).truck_number }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Telefon</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).phone_number }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Adresse</b>
                        </div>
                        <div class="col-md-5 mb-2">{{JSON.parse(trucker.data).adresss}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Postnummer</b>
                        </div>
                        <div class="col-md-5 mb-2">{{JSON.parse(trucker.data).zip_code}}</div>
                        <div class="col-md-5 mb-2">
                            <b>By</b>
                        </div>
                        <div class="col-md-5 mb-2">{{JSON.parse(trucker.data).city}}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <h4>Bilforsikring</h4>
                    <div class="row">
                        <div class="col-md-5 mb-2">
                            <b>Reg nummer</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).reg_number }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Serienummer</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).serial_number }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Nyværdi</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).new_value_id}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Selvrisiko</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).own_risk_id}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Hvor kører du?</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).area_id}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Antal skader de sidste tre år, som taxavognmand</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).injury_id}}</div>
                    </div>
                </div>

                <div class="col-md-4">
                    <h4 class="0" style="margin-top: 65px"></h4>
                    <div class="row">
                        <div class="col-md-5 mb-2">
                            <b>Vejhjælp</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).addon_1}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Glasskade</b>
                        </div>
                        <div class="col-md-5 mb-2">{{ JSON.parse(trucker.data).addon_2}}</div>
                        <div class="col-md-5 mb-2"  v-if="JSON.parse(trucker.data).addon_1 == 1">
                            <b>Vejhjælp aktiv pr.:</b>
                        </div>
                        <div class="col-md-7 mb-2"  v-if="JSON.parse(trucker.data).addon_1 == 1">{{ JSON.parse(trucker.data).addon_1_date }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Policenummer</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).police_number }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Dato for opsigelse</b>
                        </div>
                        <div class="col-md-7 mb-2">{{ JSON.parse(trucker.data).termination_date }}</div>
                        <div class="col-md-5 mb-2">
                            <b>Arbejdsskade forsikring</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).is_work_insurance}}</div>
                        <div class="col-md-5 mb-2">
                            <b>Tidligere forsikring</b>
                        </div>
                        <div class="col-md-7 mb-2">{{JSON.parse(trucker.data).previous_insurance}}</div>
                    </div>
                </div>
            </div>

          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <div class="jumbotron" v-if="truckers.length == 0">
        <h4 class="display-6 text-center">Ingen Trucker Historier fundet</h4>
    </div>
</div>

</template>

<script>
import Vue from 'vue'

export default {
    data () {
        return {
            truckers:[],
        }
    },

    methods:{
        async trucker_history()
        {
            let loader = this.$loading.show()
            try
            {
                let data_obj = await Vue.prototype.$http.get('/api/truckers/trucker-history/'+ this.$route.params.id)
                // if(data_obj.data.data)
                this.truckers = (data_obj.data)
                loader.hide()

            }
            catch(e)
            {
                loader.hide()
				this.$store.dispatch("notifications_alert/error", e.response.data.message)
            }
        }
    },

    created(){
        this.trucker_history()
    }
}
</script>